module.exports = __webpack_public_path__ + "static/media/testing.bbcd082d.svg";